<template>
	<div class="InvalidTokenView" :data-cy="dataCy">
		<v-icon size="64" :color="iconColor">{{ icon }}</v-icon>
		<h1>{{ title || $t('text.invalidOrExpiredLink') }}</h1>
		<p>{{ detail || $t('text.invalidOrExpiredLinkDetail') }}</p>
	</div>
</template>

<script>
export default {
	name: 'InvalidTokenView',
	props: {
		title: { type: String, default: '' },
		detail: { type: String, default: '' },
		icon: { type: String, default: 'mdi-link-variant-off' },
		iconColor: { type: String, default: '#f34545' },
		dataCy: { type: String, default: 'invalidToken' },
	},
}
</script>

<style scoped>
.InvalidTokenView {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 16px;
	min-height: 60vh;
	text-align: center;
	padding: 32px;
}
.InvalidTokenView h1 { font-size: 24px; font-weight: 600; }
.InvalidTokenView p { color: #8f8f8f; }
</style>
